import { render, staticRenderFns } from "./withdrawalAudit.vue?vue&type=template&id=4d24a84e&scoped=true&"
import script from "./withdrawalAudit.vue?vue&type=script&lang=js&"
export * from "./withdrawalAudit.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalAudit.vue?vue&type=style&index=0&id=4d24a84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24a84e",
  null
  
)

component.options.__file = "withdrawalAudit.vue"
export default component.exports